import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

import { CommonModule } from '@angular/common'
import { TranslatePipe } from '@ngx-translate/core'
import { MatDialogModule } from '@angular/material/dialog'

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslatePipe, MatDialogModule]
})
export class ConfirmDialogComponent implements OnInit {
  title = ''
  message = ''
  subMessage = ''
  image = ''
  isDelete: boolean = true
  isApproved: boolean = false
  primaryBtnTitle: string = ''
  secondaryTitle: string = ''
  currentLanguage: string | null = ''

  constructor(
    public dialog: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.currentLanguage = localStorage.getItem('lang')
  }

  ngOnInit(): void {
    this.title = this.data.title
    this.message = this.data.message
    this.subMessage = this.data.subMessage
    this.image = this.data.image
    this.primaryBtnTitle = this.data.primaryBtnTitle
    this.secondaryTitle = this.data.secondaryTitle

    if (this.data.isDelete !== undefined) this.isDelete = this.data.isDelete
  }

  confirm() {
    this.dialog.close(true)
  }
}
